import { Component, OnInit } from '@angular/core';
import { Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { BehfaService } from 'src/app/Service/Behfa/Behfa.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-BehfaList',
  templateUrl: './BehfaList.component.html',
  styleUrls: ['./BehfaList.component.scss']
})
export class BehfaListComponent implements OnInit {
  BaseUrl=environment.BaseUrl

  constructor(
    private Behfa_Service:BehfaService,
    private Nav_Service:NavService,
  ) { }

  DataList_Behfa:Array<Behfa_Interface>=[]

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1112).subscribe(
      data=>{
        this.ReadData_Behfa()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Behfa(){
    this.Behfa_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Behfa=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }
}
